/**
 * Teto dos campos de observação — espelha o `OBSERVACOES_MAX_LENGTH` do backend
 * (`src/common/text-limits.ts`), que é quem valida de fato.
 *
 * Subiu de 1000 para 10.000 na at-58 (06/08/2026): o limite antigo era pouco
 * para relatos reais. Vale para as Observações do Cliente e da Oficina do
 * atendimento (at-54) e para as Observações de Entrada/Saída do checklist
 * (at-50). A observação por ITEM de checklist (at-34) continua em 200.
 */
export const OBSERVACOES_MAX_LENGTH = 10000;
